import { ProductPrice } from '~/Product';

import ProductComputedPrice from './ProductComputedPrice';

export default class ReferencePrice {
	public readonly calculatedPrice: ProductComputedPrice;

	public readonly sourcePrice: ProductPrice;

	public constructor(sourcePrice: ProductPrice, calculatedPrice: ProductComputedPrice) {
		this.sourcePrice = sourcePrice;
		this.calculatedPrice = calculatedPrice;
	}
}
